export default __webpack_public_path__ + "static/media/3065.0732ec46.jpg";